import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from 'react-bootstrap';
import { useToasts } from "react-toast-notifications";
import {
  setGastosFijos,
  guardaGastosFijos,
} from "../../redux/gastosFijos/gastosFijosActions";
import GastosFijosForm from "../../components/GastosFijosForm";

export const GastosFijos = ({ onSaved, showSubmit = true }) => {
  const item = { rubro: "", concepto: "", valor: "" };
  const [rubroId, setRubroId] = React.useState("");
  const rubros = ["SUELDOS", "LOCAL", "FONDO", "APOYO", "OTROS"];
  const sesion = useSelector((state) => state.sesion);
  const empresa = useSelector((state) => state.empresa);
  const gastosFijos = useSelector((state) => state.gastosFijos);
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [isSaving, setIsSaving] = React.useState(false);

  React.useEffect(() => {
    if (
      (!gastosFijos.dias || gastosFijos.dias === 0) &&
      (!gastosFijos.horas || gastosFijos.horas === 0) &&
      (!gastosFijos.items || gastosFijos.items.length === 0)
    ) {
      dispatch(setGastosFijos({
        dias: 20,
        horas: 8,
        items: [{ rubro: 'SUELDOS', concepto: 'Sueldo base', valor: 3000 }]
      }));
    }
    // eslint-disable-next-line
  }, []);

  const getCostoMinuto = () => {
    const dias = parseInt(gastosFijos.dias, 10) || 0;
    const horas = parseFloat(gastosFijos.horas) || 0;
    const minutosTrabajados = horas * 60 * dias;
    const totalGastos = getTotalGastos();
    const costoMinuto = minutosTrabajados > 0 ? (Math.round((totalGastos / minutosTrabajados) * 100) / 100) : 0;
    return costoMinuto;
  };

  const getCostoHora = () => {
    const dias = parseInt(gastosFijos.dias, 10) || 0;
    const horas = parseFloat(gastosFijos.horas) || 0;
    const horasTrabajadas = horas * dias;
    const totalGastos = getTotalGastos();
    const costoHora = horasTrabajadas > 0 ? (Math.round((totalGastos / horasTrabajadas) * 100) / 100) : 0;
    return costoHora;
  };

  function getTotalGastos() {
    const total = gastosFijos.items.length > 0
      ? gastosFijos.items
        .map((item) => item.valor)
        .reduce((acc, valor) => Number(acc) + Number(valor), 0)
      : 0;
    return total;
  }

  const handleAddItem = (e) => {
    e.preventDefault();
    if (!rubroId) {
      addToast("Seleccione un rubro", { appearance: "error" });
      return;
    }
    dispatch(
      setGastosFijos({
        ...gastosFijos,
        items: [...gastosFijos.items, { ...item, rubro: rubroId }],
      })
    );
  };

  const handleDeleteItem = (index) => {
    let valores = [...gastosFijos.items];
    valores.splice(index, 1);
    dispatch(setGastosFijos({ ...gastosFijos, items: valores }));
  };

  const handleChangeItems = (index, e) => {
    let valores = [...gastosFijos.items];
    valores[index][e.target.name] = e.target.value;
    dispatch(setGastosFijos({ ...gastosFijos, items: valores }));
  };

  const handleChangeProperty = (e) => {
    let valores = { ...gastosFijos };
    valores[e.target.name] = e.target.value;
    dispatch(setGastosFijos(valores));
  };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
      setIsSaving(true);
    setIsSaving(true);
    gastosFijos.empresaId = empresa.id;
    gastosFijos.fecha = new Date();
    gastosFijos.usuario = sesion.usuario.email;
    gastosFijos.costoMinuto = getCostoMinuto();
    gastosFijos.total = getTotalGastos();
    try {
      await dispatch(guardaGastosFijos(gastosFijos));
      addToast("Se guardaron los cambios satisfactoriamente", {
        appearance: "success",
      });
      if (onSaved) onSaved();
    } catch (err) {
      addToast(err.message, { appearance: "error" });
    }
    setIsSaving(false);
  };

  if (sesion.loading || sesion.loading === undefined)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden"></span>
        </Spinner>
      </div>
    );
  if (sesion.error) return <div>{`ocurrio un error ${sesion.error} `}</div>;

  return (
    <GastosFijosForm
      gastosFijos={gastosFijos}
      rubros={rubros}
      rubroId={rubroId}
      setRubroId={setRubroId}
      loading={false}
      onChangeProperty={handleChangeProperty}
      onChangeItems={handleChangeItems}
      onAddItem={handleAddItem}
      onDeleteItem={handleDeleteItem}
      onSave={handleSave}
      isSaving={isSaving}
      getCostoHora={getCostoHora}
      getCostoMinuto={getCostoMinuto}
      getTotalGastos={getTotalGastos}
      showSubmit={showSubmit}
    />
  );
};
